import {PageHeading} from "@ui-components/Container";
import React from "react";
import {FormattedMessage} from "react-intl";
import {useQuotations} from "../../feature/quotations/hooks/useQuotations";
import {QuotationsTable, Quotation} from "../../feature/quotations";
import {useParams} from "react-router-dom";

const Quotations = () => {

  // params
  const {quotation_id} = useParams<{quotation_id: string}>();

  // hooks
  const { fetch, deleteOne, loading } = useQuotations();

  return (
    <div className="py-4">
      <PageHeading
        title={<FormattedMessage id="quotations"/>}
        contentActions={undefined}
      />
      <QuotationsTable
        onFetch={fetch}
        onDelete={deleteOne}
        loading={loading}
      />
      {!!quotation_id && (
        <div className="fixed bg-white inset-0 z-50 animate-slideLeftIn overflow-y-auto">
          <Quotation
            id={parseInt(quotation_id)}
          />
        </div>
      )}
    </div>
  )
}

export default Quotations;